<template>
  <div>
    <TransactionsList
      :isSubTab="isSubTab"
      :payoutData="payoutData"
      :payoutsTransactions="true"
    >
    <template v-slot:mergeButtons>
      <b-button
        v-if="isInReviewOrReportGenerated && permissions.pages[Pages.PayoutsList].canWrite"
        size="sm"
        class="ml-2 btn-outline-red"
        @click="$bvModal.show('generate-statements-modal')"
      >
        {{ $t("generate_statements") | capitalize }}
      </b-button>
    </template>
    <template v-slot:footerButtons>
      <div class="fixed-footer">
        <div class="d-flex justify-content-end">
          <b-button v-if="canEdit" class="btn-outline-dark mr-3" @click="prevTab">
            {{ $t("modify_scope") | capitalize }}
          </b-button>
          <!-- To-Do- This buttons is missing payoutData.syncCompleted. It'll be developed in RT2-2719 -->
          <b-button
            v-if="isInReview"
            class="mr-3 btn-outline-red"
            @click="$bvModal.show('finalize-payout-modal')"
            :disabled="finalizing"
          >
            {{ $t("finalize_payout") | capitalize }}
          </b-button>
        </div>
      </div>
    </template>
  </TransactionsList>
  <modal
    id="finalize-payout-modal"
    :cancel-title="$t('cancel') | capitalize"
    :ok-title="$t('confirm') | capitalize"
    @ok="finalizePayout()"
    @cancel="$bvModal.hide('finalize-payout-modal')"
    modal-type="info"
    centered
    :custom-title="$t('finalize_payout') | capitalize"
  >
    {{ $t("confirm_finalize_payout") }}
  </modal>
  <modal
    id="generate-statements-modal"
    :cancel-title="$t('cancel') | capitalize"
    :ok-title="$t('confirm') | capitalize"
    @ok="generateStatements()"
    @cancel="$bvModal.hide('generate-statements-modal')"
    modal-type="info"
    centered
    :custom-title="$t('generate_statements') | capitalize"
  >
    {{ $t("confirm_generate_statements") }}
  </modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex"
import { Pages } from "@/utils/pages"
import TransactionsList from "@/pages/Transactions/TransactionsList.vue"
import { payoutStatuses } from "@/constants"
export default {
  name: "TransactionsSection",
  components: { TransactionsList },
  props: {
    isSubTab: Boolean,
    payoutData: Object,
    canEdit: Boolean,
  },
  data () {
    return {
      payoutStatuses,
      Pages,
      finalizing: false,
    }
  },
  computed: {
    ...mapState("user", ["permissions"]),
    isInReviewOrReportGenerated () {
      return [payoutStatuses.IN_REVIEW, payoutStatuses.REPORT_GENERATED].includes(this.payoutData.status)
    },
    isInReview () {
      return this.payoutData.status === payoutStatuses.IN_REVIEW
    },
  },
  methods: {
    ...mapMutations("alert", ["error"]),
    ...mapActions("alert", ["success"]),
    prevTab () {
      this.$parent.$parent.previousTab()
    },
    async finalizePayout () {
      this.finalizing = true
      try {
        await this.$api.payouts.finalizePayout(this.payoutData.id)
        this.success(this.$options.filters.capitalize(this.$t("payout_finalization_started")))
        this.$emit("payout-status-update", payoutStatuses.FINALIZATION_IN_PROGRESS)
      } catch (err) {
        this.error(`${this.$options.filters.capitalize(this.$t("error_occurred"))} \n ${JSON.stringify(err.response?.data)}`)
      } finally {
        this.finalizing = false
      }
    },
    async generateStatements () {
      this.$emit("payout-status-update", payoutStatuses.REPORT_REQUESTED)
      try {
        await this.$api.payouts.generateStatements(this.payoutData.id)
        this.success(this.$options.filters.capitalize(this.$t("statements_generation_started")))
      } catch (err) {
        if (err.response?.status === 409) {
          this.error(this.$options.filters.capitalize(this.$t("payout_invalid_status_for_statements")))
        } else {
          this.error(`${this.$options.filters.capitalize(this.$t("error_occurred"))} \n ${JSON.stringify(err.response?.data)}`)
        }
      }
    },
  }
}
</script>
